export class UserTransformer {
  static transform(obj) {
    let user = {};

    user.id = obj.id;
    user.third_party_code = obj.attributes.third_party_code;
    user.firm_id = obj.attributes.firm_id;
    user.contract_id = obj.attributes.contract_id;
    user.name = obj.attributes.name;
    user.email = obj.attributes.email;
    user.isAdmin = obj.attributes.is_admin;
    user.createdAt = obj.attributes.created_at;
    user.updatedAt = obj.attributes.updated_at;
    user.archivedAt = obj.attributes.archived_at;

    return user;
  }
}
